// Freshness of a worker payload. The payload's `ts` is the worker's wall clock at response time and says
// nothing about how far the index is behind the chain. `as_of` is the timestamp of the indexed head and
// `head_lag_s` the distance between that head and the chain; a large lag means the figures are old even
// when the request succeeded.
import { parseTs } from '../lib/format';

/** Head lag above which a successful answer is shown as stale (seconds). */
export const STALE_HEAD_LAG_S = 900;

export interface Freshness {
  /** Indexed head time (as_of), or null when the worker did not state one. */
  indexedAt: Date | null;
  /** Seconds between the indexed head and the chain head; null when not stated. */
  headLagS: number | null;
  /** True when the head lag is above STALE_HEAD_LAG_S or the indexed time is missing. */
  stale: boolean;
}

export interface FreshnessSource {
  as_of?: string | null;
  head_lag_s?: number | null;
}

export function freshness(p: FreshnessSource, staleAfterS: number = STALE_HEAD_LAG_S): Freshness {
  const indexedAt = parseTs(p.as_of ?? null);
  const headLagS = typeof p.head_lag_s === 'number' && Number.isFinite(p.head_lag_s) ? p.head_lag_s : null;
  const stale = indexedAt === null || (headLagS !== null && headLagS > staleAfterS);
  return { indexedAt, headLagS, stale };
}
